import styled from 'styled-components'
import { colors } from '../../styles/utilities/variables'

export const StyledRevenueList = styled.div`
  background-color: ${colors.darkGreen};
`
